<script>
  import { debounce } from 'lodash';
  import {onMount} from 'svelte';

  let name = ''
  let players = []

  let playersVisible = false
  let isLoading = false
  let hasSearched = false

  const debounceAndAskToApi = debounce(function() {
    askToApi()
  }, 500);

  function authenticityToken(){
    return document.querySelector('meta[name="csrf-token"]').content
  }

  async function askToApi(){
    const query = name.trim()
    if (query.length < 2) {
      players = []
      playersVisible = false
      isLoading = false
      hasSearched = false
      return
    }

    try {
      isLoading = true
      hasSearched = true
      playersVisible = true
      const response = await fetch(`/api/search?q=${encodeURIComponent(query)}`)
      const data = await response.json()
      players = data.players
      playersVisible = true
    } catch (_error) {
      players = []
      playersVisible = false
    } finally {
      isLoading = false
    }
  }

  onMount(() => {
    window.addEventListener('click', e => {
      // Check if the target element is a descendant of the element with the visible class
      if (!e.target.closest('.suggerimenti')) {
        playersVisible = false;
      }
    });
  });
</script>
<div class="search-widget">
  <form class="site-search-form" action="/ricerche" method="post" role="search">
    <input class="form-control site-search-input" bind:value={name} autocomplete="off" type="text" name="q" id="q" aria-label="Cerca giocatore" placeholder="Cerca giocatore" on:input={debounceAndAskToApi}>
    <input name="authenticity_token" type="hidden" value="{authenticityToken()}" />
    <button name="button" type="submit" class="btn btn-outline-primary site-search-button" aria-label="Cerca">
      <i class="fas fa-search" aria-hidden="true"></i>
    </button>
  </form>
  {#if playersVisible && (isLoading || hasSearched)}
	  <div class="search-suggestions suggerimenti">
      {#if isLoading}
        <div class="search-suggestion-state" role="status" aria-live="polite">
          <i class="fas fa-spinner" aria-hidden="true"></i>
          Cerco giocatori...
        </div>
      {:else if players.length > 0}
        <ul class="search-suggestion-list">
        {#each players as player}
          <li class="search-suggestion-item">
            <a class="search-suggestion-link" href="{player.url}">
              <span class="search-suggestion-icon" aria-hidden="true">
                {#if player.image_url}
                  <img src="{player.image_url}" alt="" loading="lazy" width="32" height="32">
                {:else}
                  <i class="fas fa-user"></i>
                {/if}
              </span>
              <span class="search-suggestion-copy">
                <span class="search-suggestion-name">{player.name}</span>
                <span class="search-suggestion-meta">Giocatore</span>
              </span>
              <i class="fas fa-arrow-right search-suggestion-arrow" aria-hidden="true"></i>
            </a>
          </li>
        {/each}
        </ul>
      {:else}
        <div class="search-suggestion-state" role="status" aria-live="polite">
          Nessun giocatore trovato
        </div>
      {/if}
	  </div>
  {/if}
</div>
<style>
  .search-widget{
    position: relative;
  }
</style>
